// 1602168579 to 09-05 22:24
exports.mmddhhmm = (time) => {
    if (time) {
        // time = time * 1000
        let d = new Date(time)
        let month = d.getMonth();
        let day = d.getDate();
        let hour = d.getHours();
        let min = d.getMinutes();
        return month + "-" + day + " " + hour + ":" + min

        // return f.formatDate(date, 'MM-dd hh:mm')
    } else {
        return time
    }
};
exports.mmddhhmmDate = (date) => {
    if (date) {
        let month = date.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        let d = date.getDate();
        d = d < 10 ? '0' + d : d;
        let h = date.getHours();
        h = h < 10 ? '0' + h : h;
        let m = date.getMinutes();
        m = m < 10 ? '0' + m : m;
        return month + "-" + d + " " + h + ":" + m
    } else {
        return date
    }
};
// dateformat('MM-dd hh:mm')
exports.dateformat = (time, fmt, type) => {
    // console.log(time, fmt)
    if (!type) {
        time = time * 1000
    }
    let date = new Date(time)
    let o = {
        "y+": date.getUTCFullYear(), //年份
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
};


// 2020-09-05T22:24:00 to 09-05 22:24
exports.strmmddhhmm = (time) => {
    if (time) {
        return time.substring(5, 16).replace("T", " ")
    } else {
        return time
    }
};

// 2020-09-05T22:24:00 to 09-05 22:24
exports.stryyyymmddhhmm = (time) => {
    if (time) {
        return time.replace("T", " ")
    } else {
        return time
    }
};

exports.difference1 = (longtime) => {
    var begin = longtime[0] * 1000
    var end = longtime[1] * 1000
    var usedTime = end - begin; //两个时间戳相差的毫秒数
    var days = Math.floor(usedTime / (24 * 3600 * 1000));
    //计算出小时数
    var leave1 = usedTime % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000));
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000));
    var time = ""
    if (days > 0) {
        time = days + "天"
        time += hours + "小时"
        return time;
    } else {
        if (hours > 0) {
            time += hours + "小时"
        }
        time += minutes + "分";
        return time;
    }

}
exports.difference2 = (longtime) => {
    var usedTime = longtime*1000; //两个时间戳相差的毫秒数
    var days = Math.floor(usedTime / (24 * 3600 * 1000));
    //计算出小时数
    var leave1 = usedTime % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000));
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000));
    var time = ""
    if (days > 0) {
        time = days + "天"
        time += hours + "小时"
        return time;
    } else {
        if (hours > 0) {
            time += hours + "小时"
        }
        time += minutes + "分";
        return time;
    }

}

exports.num_thousandth = (value) => {
    if (value) {
        return value.toLocaleString()
    } else {
        return value
    }
};

exports.num_decimal = (value) => {
    if (value) {
        return parseFloat(value).toFixed(2)
    } else {
        return value
    }
};
exports.num_len = (value, len = 2) => {
    if (value) {
        return parseFloat(value).toFixed(len)
    } else {
        return value
    }
};
exports.num_len1 = (value, len = 1) => {
    if (value) {
        return parseFloat(value).toFixed(len)
    } else {
        return value
    }
};
exports.num_per = (value, num = 2) => {
    let realVal = ''
    if (value !== null && !isNaN(value) && value !== '') {
        // 截取当前数据到小数点后两位
        realVal = parseFloat(value).toFixed(num)
    } else {
        realVal = ''
    }
    return realVal + ' %'
},
exports.num_percent = (value) => {
    let realVal = ''
    if (value !== null && !isNaN(value) && value !== '') {
        // 截取当前数据到小数点后两位
        realVal = parseFloat(value * 100).toFixed(0)
    } else {
        realVal = ''
    }
    return realVal + ' %'
},
exports.num_w = (value) => {
    let realVal = ''
    if (value !== null && !isNaN(value) && value !== '') {
        // 截取当前数据到小数点后两位
        if (value > 10000 * 10000 | value < -10000 * 10000) {
            realVal = parseFloat(value / 10000 / 10000).toFixed(1) + '亿'
        } else if (value > 10000 | value < -10000) {
            realVal = parseFloat(value / 10000).toFixed(1) + 'w'
        } else {
            realVal = value.toLocaleString()
        }
    } else {
        realVal = '--'
    }
    return realVal
}

exports.num_w0 = (value) => {
    let realVal = ''
    if (value !== null && !isNaN(value) && value !== '') {
        // 截取当前数据到小数点后两位
        if (value > 10000 * 10000) {
            realVal = parseFloat(value / 10000 / 10000).toFixed(1) + '亿'
        } else if (value > 10000) {
            realVal = parseFloat(value / 10000).toFixed(1) + 'w'
        } else {
            realVal = Math.round(value).toLocaleString()
        }

    } else {
        realVal = ''
    }
    return realVal
}
exports.level_ = (value) => {
    let realVal = ''
    if (value !== null && !isNaN(value) && value !== '') {
        if (value < 500) {
            realVal = "E"
        } else if (value >= 500 && value < 4000) {
            realVal = "D"

        } else if (value >= 4000 && value < 30000) {
            realVal = "C"

        } else if (value >= 30000 && value < 200000) {
            realVal = "B"

        } else if (value >= 200000 && value < 1000000) {
            realVal = "A"

        } else if (value >= 1000000 && value < 10000000) {
            realVal = "S"

        } else if (value >= 10000000 && value < 20000000) {
            realVal = "SS"

        } else if (value >= 20000000) {
            realVal = "SSS"
        }
    }
    return realVal
};

exports.level = (value) => {
    let realVal = ''
    if (value !== null && !isNaN(value) && value !== '') {
        if (value < 75) {
            realVal = "E0"
        } else if (value < 500) {
            realVal = "E" + parseFloat((value / 500) * 10 - 1).toFixed(0)
        } else if (value >= 500 && value < 4000) {
            realVal = "D" + parseFloat((value / 4000) * 10 - 1).toFixed(0)
        } else if (value >= 4000 && value < 30000) {
            realVal = "C" + parseFloat((value / 30000) * 10 - 1).toFixed(0)
        } else if (value >= 30000 && value < 200000) {
            realVal = "B" + parseFloat((value / 200000) * 10 - 1).toFixed(0)
        } else if (value >= 200000 && value < 1000000) {
            realVal = "A" + parseFloat((value / 1000000) * 10 - 1).toFixed(0)
        } else if (value >= 1000000 && value < 10000000) {
            realVal = "S" + parseFloat((value / 10000000) * 10 - 1).toFixed(0)
        } else if (value >= 10000000 && value < 20000000) {
            realVal = "SS" + parseFloat((value / 20000000) * 10 - 1).toFixed(0)
        } else if (value >= 20000000) {
            realVal = "SSS"
        }
    }
    return realVal
};

exports.level_number = (value) => {
    let realVal = ''
    if (value !== null && !isNaN(value) && value !== '') {
        if (value < 75) {
            realVal = "0.0"
        } else if (value < 500) {
            realVal = "0" + "." + parseFloat((value / 500) * 10 - 1).toFixed(0)
        } else if (value >= 500 && value < 4000) {
            realVal = "1" + "." + parseFloat((value / 4000) * 10 - 1).toFixed(0)
        } else if (value >= 4000 && value < 30000) {
            realVal = "2" + "." + parseFloat((value / 30000) * 10 - 1).toFixed(0)
        } else if (value >= 30000 && value < 200000) {
            realVal = "3" + "." + parseFloat((value / 200000) * 10 - 1).toFixed(0)
        } else if (value >= 200000 && value < 1000000) {
            realVal = "4" + "." + parseFloat((value / 1000000) * 10 - 1).toFixed(0)
        } else if (value >= 1000000 && value < 10000000) {
            realVal = "5" + "." + parseFloat((value / 10000000) * 10 - 1).toFixed(0)
        } else if (value >= 10000000 && value < 20000000) {
            realVal = "6" + "." + parseFloat((value / 20000000) * 10 - 1).toFixed(0)
        } else if (value >= 20000000) {
            realVal = "7"
        }
    }
    return realVal
};

exports.level_retention = (value) => {
    let realVal = ''
    if (value !== null && !isNaN(value) && value !== '') {
        if (value < 1) {
            realVal = "极差"
        } else if (value >= 1 && value < 3) {
            realVal = "普通"
        } else if (value >= 3 && value < 5) {
            realVal = "较好"
        } else if (value >= 5 && value < 7) {
            realVal = "优秀"
        } else if (value >= 7 && value < 10) {
            realVal = "超级"
        } else if (value >= 10 && value < 15) {
            realVal = "极度"
        } else if (value >= 15 && value < 30) {
            realVal = "有水"
        } else if (value >= 30) {
            realVal = "超级水"
        }
    }
    return realVal
};

exports.str_br = (value) => {
    let str1 = value.replace(/\n/g, '<br>')
    return str1
}
exports.str_sub = (value, stop) => {
    return value.substring(0, stop)
}

exports.str_if = (value, str) => {
    if (value !== null && isNaN(value) && value === '') {
        return str
    } else {
        return value
    }
}

exports.formatSeconds = (value) => {
    var theTime = parseInt(value);// 秒
    var theTime1 = 0;// 分
    var theTime2 = 0;// 小时
    var result = "";
    if (theTime >= 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (theTime1 > 60) {
            theTime2 = parseInt(theTime1 / 60);
            theTime1 = parseInt(theTime1 % 60);
        }
    } else {
        result = theTime + "秒"
    }
    if (theTime1 > 0) {
        result = "" + parseInt(theTime1) + "分" + result;
    }
    if (theTime2 > 0) {
        result = "" + parseInt(theTime2) + "小时" + result;
    }
    return result;
}
exports.formatSeconds1 = (value) => {
    var theTime = parseInt(value);// 秒
    var theTime1 = 0;// 分
    var theTime2 = 0;// 小时
    var result = "";
    if (theTime >= 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (theTime1 > 60) {
            theTime2 = parseInt(theTime1 / 60);
            theTime1 = parseInt(theTime1 % 60);
        }
    } else {
        result = theTime + "s"
    }
    if (theTime1 > 0) {
        result = "" + parseInt(theTime1) + "m" + result;
    }
    if (theTime2 > 0) {
        result = "" + parseInt(theTime2) + "h" + result;
    }
    return result;
}
// 分配价位
exports.priceClassification = (goodsList,type) => {
    let totalPrice = 0;
    goodsList.forEach((c) => {
        totalPrice += c[type];
    })
    // 商品平均价
    let averagePrice = totalPrice / goodsList.length;
    // 商品最高价
    let maxPrice = Math.max.apply(Math, goodsList.map((c) => {
            return c[type]
        }
    ));
    // 商品最低价
    let minPrice = Math.min.apply(Math, goodsList.map((c) => {
            return c[type]
        }
    ));
    // 低等价位（最低价）
    let lowGrade = Math.floor(minPrice / 100);
    // 中等价位（平均价-最低价x50%+最低价）
    let secondary = Math.floor(((averagePrice - minPrice) * 0.5 + minPrice) / 100);
    // 高等价位（最高价-平均价x50%+平均价）
    let higher = Math.ceil(((maxPrice - averagePrice) * 0.5 + averagePrice) / 100);
    // 返回数据
    return {
        lowGrade:lowGrade,
        secondary: secondary,
        higher: higher
    }
}
// 分配等级
exports.gradeClassification = (goodsList,type) => {
    let totalPrice = 0;
    goodsList.forEach((c) => {
        totalPrice += c[type];
    })
    // 商品平均价
    let averagePrice = totalPrice / goodsList.length;
    // 商品最高价
    let maxPrice = Math.max.apply(Math, goodsList.map((c) => {
            return c[type]
        }
    ));
    // 商品最低价
    let minPrice = Math.min.apply(Math, goodsList.map((c) => {
            return c[type]
        }
    ));
    // 低等价位（最低价）
    let lowGrade = Math.floor( minPrice);
    // 中等价位（平均价-最低价x50%+最低价）
    let secondary = Math.floor((averagePrice - minPrice) * 0.5 + minPrice);
    // 高等价位（最高价-平均价x50%+平均价）
    let higher = Math.ceil((maxPrice - averagePrice) * 0.5 + averagePrice);
    // 返回数据
    return {
        lowGrade:lowGrade,
        secondary: secondary,
        higher: higher
    }
}

// 加法函数
exports.accAdd = (arg1, arg2) => {
    if (!arg1) arg1 = 0;
    if (!arg2) arg2 = 0;
    let r1, r2, m, c;
    try {
      r1 = arg1.toString().split(".")[1].length;
    }
    catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split(".")[1].length;
    }
    catch (e) {
      r2 = 0;
    }
    c = Math.abs(r1 - r2);
    m = Math.pow(10, Math.max(r1, r2));
    if (c > 0) {
      let cm = Math.pow(10, c);
      if (r1 > r2) {
        arg1 = Number(arg1.toString().replace(".", ""));
        arg2 = Number(arg2.toString().replace(".", "")) * cm;
      } else {
        arg1 = Number(arg1.toString().replace(".", "")) * cm;
        arg2 = Number(arg2.toString().replace(".", ""));
      }
    } else {
      arg1 = Number(arg1.toString().replace(".", ""));
      arg2 = Number(arg2.toString().replace(".", ""));
    }
    return (arg1 + arg2) / m;
  }

  // 減法函數
  exports.accSub = (arg1, arg2) => {
    if (!arg1) arg1 = 0;
    if (!arg2) arg2 = 0;
    var r1, r2, m, n;
    try {
      r1 = arg1.toString().split(".")[1].length;
    }
    catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split(".")[1].length;
    }
    catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
    n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
  }

  // 乘法
  exports.accMul = (arg1, arg2) => {
    if (!arg1) arg1 = 0;
    if (!arg2) arg2 = 0;
    var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length;
    }
    catch (e) {
    }
    try {
      m += s2.split(".")[1].length;
    }
    catch (e) {
    }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
  }

  // 除法
  exports.accDiv = (arg1, arg2) => {
    if (!arg1) arg1 = 0;
    if (!arg2) arg2 = 0;
    var t1 = 0, t2 = 0, r1, r2;
    try {
      t1 = arg1.toString().split(".")[1].length;
    }
    catch (e) {
    }
    try {
      t2 = arg2.toString().split(".")[1].length;
    }
    catch (e) {
    }
    r1 = Number(arg1.toString().replace(".", ""));
    r2 = Number(arg2.toString().replace(".", ""));
    return (r1 / r2) * Math.pow(10, t2 - t1);
  }


// WEBPACK FOOTER //
// ./src/filters/index.js